import {
  FETCH_COMPANY_PROFILE_REQUEST,
  FETCH_COMPANY_PROFILE_SUCCESS,
  FETCH_COMPANY_PROFILE_FAILURE,
  CHECK_COMPANY_PROFILE,
  FETCH_COMPANIES_REQUEST,
  FETCH_COMPANIES_SUCCESS,
  FETCH_COMPANIES_FAILURE,
  PATCH_COMPANY_REQUEST,
  PATCH_COMPANY_SUCCESS,
  PATCH_COMPANY_FAILURE,
} from './companyTypes';

const initialState = {
  // legacy aggregate (kept for compatibility)
  loading: false,

  // new scoped flags
  loadingProfile: false,
  loadingCompanies: false,

  companyName: null,
  companyRootAPPBID: null,
  companyStatus: null,
  companyIsFirstHandler: false,
  companyIsImporter: false,
  companyIsProducer: false,
  companyProfile: [], // keep shape as in your current app
  error: '',
  companies: [],
};

function companyReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_COMPANY_PROFILE_REQUEST:
      return {
        ...state,
        loadingProfile: true,
        loading: true,
      };
    case FETCH_COMPANY_PROFILE_SUCCESS:
      return {
        ...state,
        loadingProfile: false,
        loading: state.loadingCompanies, // aggregate = OR of scoped flags
        companyName: action.companyName,
        companyRootAPPBID: action.companyRootAPPBID,
        companyStatus: action.companyStatus,
        companyIsFirstHandler: action.companyIsFirstHandler,
        companyIsImporter: action.companyIsImporter,
        companyIsProducer: action.companyIsProducer,
        companyProfile: action.companyProfile,
        error: '',
      };
    case FETCH_COMPANY_PROFILE_FAILURE:
      return {
        ...state,
        loadingProfile: false,
        loading: state.loadingCompanies,
        error: action.payload,
      };

    case CHECK_COMPANY_PROFILE:
      return {
        ...state,
        companyName: action.companyName,
        companyRootAPPBID: action.companyRootAPPBID,
        companyStatus: action.companyStatus,
        companyIsFirstHandler: action.companyIsFirstHandler,
        companyIsImporter: action.companyIsImporter,
        companyIsProducer: action.companyIsProducer,
        companyProfile: action.companyProfile,
        companies: action.companies,
      };

    case FETCH_COMPANIES_REQUEST:
      return {
        ...state,
        loadingCompanies: true,
        loading: true,
      };
    case FETCH_COMPANIES_SUCCESS:
      return {
        ...state,
        loadingCompanies: false,
        loading: state.loadingProfile,
        companies: action.companies,
        error: '',
      };
    case FETCH_COMPANIES_FAILURE:
      return {
        ...state,
        loadingCompanies: false,
        loading: state.loadingProfile,
        error: action.payload,
      };

    // (optional) if you dispatch PATCH_* elsewhere, keep loading stable
    case PATCH_COMPANY_REQUEST:
      return {
        ...state,
        // do not change scoped flags used by AdminMasquerade
        loading: true,
      };
    case PATCH_COMPANY_SUCCESS:
      return {
        ...state,
        loading: state.loadingProfile || state.loadingCompanies,
        error: '',
      };
    case PATCH_COMPANY_FAILURE:
      return {
        ...state,
        loading: state.loadingProfile || state.loadingCompanies,
        error: action.payload,
      };

    default:
      return state;
  }
}

export default companyReducer;
